import React from 'react';

function ArrowLeft(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M10.9416 4.45446C11.1859 4.21055 11.1862 3.81482 10.9423 3.57057C10.6983 3.32633 10.3026 3.32605 10.0584 3.56996L2.41246 11.2052C1.97256 11.6445 1.97235 12.3573 2.41199 12.7968L10.0581 20.4413C10.3022 20.6854 10.6979 20.6853 10.942 20.4412C11.186 20.1971 11.186 19.8014 10.9419 19.5574L4.01394 12.6309H21.3909C21.736 12.6309 22.0159 12.351 22.0159 12.0059C22.0159 11.6607 21.736 11.3809 21.3909 11.3809H4.00555L10.9416 4.45446Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default ArrowLeft;
